/* su-quick-view.js — extracted from snippets/su-quick-view.liquid 2026-06-12 (speed: 20KB inline -> cached asset) */
var CLOSE_LABEL = (window.SU_I18N && SU_I18N.qv_close) || 'Close';
var PICK_SIZE_LABEL = (window.SU_I18N && SU_I18N.qv_pick_size) || 'Pick a size';
if (!window.__suCardInit) {
  window.__suCardInit = true;

  /* ========== SU QUICK VIEW MODAL ========== */
  (function() {
    var modal = document.createElement('div');
    modal.id = 'su-qv';
    modal.innerHTML = '<div class="su-qv-overlay"></div><div class="su-qv-panel"><button class="su-qv-close" aria-label="' + CLOSE_LABEL + '">&times;</button><div class="su-qv-body"></div></div>';
    document.body.appendChild(modal);

    var style = document.createElement('style');
    style.textContent = '' +
      '#su-qv{position:fixed;inset:0;z-index:10000;display:none;align-items:center;justify-content:center}' +
      '#su-qv.is-open{display:flex}' +
      '.su-qv-overlay{position:absolute;inset:0;background:rgba(26,26,26,0.5);backdrop-filter:blur(4px);-webkit-backdrop-filter:blur(4px)}' +
      '.su-qv-panel{position:relative;background:var(--su-cream,#FBF7F0);border-radius:24px;max-width:860px;width:92vw;max-height:88vh;max-height:88dvh;overflow-y:auto;-webkit-overflow-scrolling:touch;box-shadow:0 24px 80px rgba(0,0,0,0.18);z-index:1;padding:32px}' +
      '.su-qv-close{position:absolute;top:12px;right:12px;background:var(--su-cream-2,#F4EEE2);border:none;border-radius:50%;width:44px;height:44px;font-size:22px;cursor:pointer;z-index:2;display:flex;align-items:center;justify-content:center;color:var(--su-ink);-webkit-tap-highlight-color:transparent}' +
      '.su-qv-body{display:grid;grid-template-columns:1fr 1fr;gap:28px;align-items:start}' +
      '@media(max-width:749px){.su-qv-body{grid-template-columns:1fr;gap:20px}.su-qv-panel{padding:20px}}' +
      '.su-qv__media{position:relative}' +
      '.su-qv__nav{position:absolute;top:50%;transform:translateY(-50%);width:38px;height:38px;border-radius:50%;border:none;background:rgba(251,247,240,.92);color:#1A1A1A;font-size:20px;cursor:pointer;z-index:2;box-shadow:0 2px 10px rgba(20,20,20,.15)}' +
      '.su-qv__nav--prev{left:10px}[dir=rtl] .su-qv__nav--prev{left:auto;right:10px}' +
      '.su-qv__nav--next{right:10px}[dir=rtl] .su-qv__nav--next{right:auto;left:10px}' +
      '.su-qv__dots{position:absolute;bottom:10px;right:12px;background:rgba(26,26,26,.72);color:#FBF7F0;font-size:12px;padding:3px 9px;border-radius:999px;z-index:2}' +
      '.su-qv__img{width:100%;border-radius:16px;background:var(--su-cream-2,#F4EEE2);aspect-ratio:1;object-fit:cover}' +
      '.su-qv__title{font-family:"Baloo 2","DM Sans",sans-serif;font-weight:600;font-size:28px;margin:0 0 8px;color:var(--su-ink);line-height:1.15}' +
      '.su-qv__price{font-family:"Baloo 2","DM Sans",sans-serif;font-weight:600;font-size:24px;color:var(--su-ink);margin-bottom:16px}' +
      '.su-qv__sizes{display:flex;flex-wrap:wrap;gap:8px;margin-bottom:20px}' +
      '.su-qv__size{min-height:44px;padding:10px 18px;border:1.5px solid var(--su-line,#E8E0D0);border-radius:999px;background:transparent;cursor:pointer;font-family:"DM Sans",sans-serif;font-size:14px;font-weight:600;color:var(--su-ink);transition:all .15s;-webkit-tap-highlight-color:transparent}' +
      '.su-qv__size:hover:not(:disabled){border-color:var(--su-ink)}' +
      '.su-qv__size.is-active{background:var(--su-ink,#1A1A1A);color:#fff;border-color:var(--su-ink)}' +
      '.su-qv__size:disabled{opacity:0.35;cursor:not-allowed;text-decoration:line-through}' +
      '.su-qv__atc{width:100%;padding:14px;background:var(--su-ink,#1A1A1A);color:#fff;border:none;border-radius:999px;font-family:"DM Sans",sans-serif;font-size:15px;font-weight:600;cursor:pointer;transition:transform .2s}' +
      '.su-qv__atc:hover:not(:disabled){transform:translateY(-2px)}' +
      '.su-qv__atc:disabled{opacity:0.4;cursor:not-allowed}' +
      '.su-qv__link{display:block;text-align:center;margin-top:12px;font-family:"DM Sans",sans-serif;font-size:13px;color:var(--su-muted,#6B6B66);text-decoration:underline}' +
      '.su-qv__loading{display:flex;justify-content:center;align-items:center;min-height:200px;grid-column:1/-1}' +

      /* Card action buttons (Quick View + Quick Add) */
      '.su-card-actions{display:flex;gap:8px;margin-top:12px;align-items:stretch}' +
      '.su-card-action{flex:1;display:inline-flex;align-items:center;justify-content:center;gap:6px;padding:10px 12px;border-radius:999px;font-family:"DM Sans",sans-serif;font-size:13px;font-weight:600;cursor:pointer;border:1.5px solid transparent;transition:transform .15s ease,background .2s,color .2s,box-shadow .2s;white-space:nowrap;line-height:1;-webkit-tap-highlight-color:transparent}' +
      '.su-card-action svg{width:14px;height:14px;flex-shrink:0}' +
      '.su-card-action--view{background:transparent;border-color:var(--su-ink,#1A1A1A);color:var(--su-ink,#1A1A1A)}' +
      '.su-card-action--view:hover{background:var(--su-ink,#1A1A1A);color:var(--su-cream,#FBF7F0)}' +
      '.su-card-action--add{background:var(--su-ink,#1A1A1A);color:var(--su-cream,#FBF7F0);border-color:var(--su-ink,#1A1A1A)}' +
      '.su-card-action--add:hover{transform:translateY(-1px);box-shadow:0 8px 18px rgba(0,0,0,0.15)}' +
      '.su-card-action:disabled,.su-card-action.is-loading{opacity:0.65;cursor:progress;pointer-events:none}' +
      '.su-card-action.is-added{background:#B5D67C;border-color:#B5D67C;color:#1A1A1A}' +
      /* Inline size picker that drops down inside the card */
      '.su-card-sizes{display:none;margin-top:10px;padding:12px;background:var(--su-cream-2,#F4EEE2);border-radius:14px;flex-wrap:wrap;gap:6px;animation:su-card-sizes-in .25s cubic-bezier(.2,.8,.2,1)}' +
      '.su-card-sizes[data-open]{display:flex}' +
      '@keyframes su-card-sizes-in{from{opacity:0;transform:translateY(-4px)}to{opacity:1;transform:none}}' +
      '.su-card-sizes__label{flex-basis:100%;font-family:"JetBrains Mono",monospace;font-size:10px;letter-spacing:0.15em;text-transform:uppercase;color:var(--su-muted,#6B6B66);margin:0 0 4px;display:flex;align-items:center;justify-content:space-between}' +
      '.su-card-sizes__close{background:transparent;border:none;cursor:pointer;color:var(--su-muted);font-size:18px;line-height:1;padding:0 4px}' +
      '.su-card-size{padding:7px 12px;border-radius:999px;border:1.5px solid var(--su-line,#E8E0D0);background:#fff;font-family:"DM Sans",sans-serif;font-size:12px;font-weight:600;cursor:pointer;transition:all .15s;color:var(--su-ink);-webkit-tap-highlight-color:transparent}' +
      '.su-card-size:hover:not(:disabled){border-color:var(--su-ink)}' +
      '.su-card-size:disabled{opacity:0.32;cursor:not-allowed;text-decoration:line-through}' +
      '.su-card-size.is-loading{background:var(--su-ink);color:var(--su-cream);border-color:var(--su-ink);cursor:progress}' +
      /* Mobile tweaks */
      '@media (max-width:480px){.su-card-action{padding:9px 10px;font-size:12px}.su-card-action svg{width:13px;height:13px}.su-card-size{padding:7px 10px;font-size:11.5px}}' +
      /* Ensure card position so inline picker doesn\'t escape */
      '.su-card-wrap,.su-product-card{position:relative}';
    document.head.appendChild(style);

    var overlay = modal.querySelector('.su-qv-overlay');
    var closeBtn = modal.querySelector('.su-qv-close');
    var bodyEl = modal.querySelector('.su-qv-body');

    function closeModal() {
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
      bodyEl.innerHTML = '';
    }
    overlay.addEventListener('click', closeModal);
    closeBtn.addEventListener('click', closeModal);
    document.addEventListener('keydown', function(e) { if (e.key === 'Escape') closeModal(); });

    document.addEventListener('click', function(e) {
      var trigger = e.target.closest('.su-quick-view-trigger');
      if (!trigger) return;
      e.preventDefault();
      e.stopPropagation();

      var handle = trigger.getAttribute('data-product-handle');
      if (!handle) return;

      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      bodyEl.innerHTML = '<div class="su-qv__loading"><svg width="36" height="36" viewBox="0 0 66 66"><circle cx="33" cy="33" r="30" fill="none" stroke="var(--su-ink)" stroke-width="4" opacity="0.2" stroke-dasharray="164" stroke-dashoffset="40"><animateTransform attributeName="transform" type="rotate" from="0 33 33" to="360 33 33" dur="0.8s" repeatCount="indefinite"/></circle></svg></div>';

      fetch('/products/' + handle + '.js')
        .then(function(r) { return r.json(); })
        .then(function(p) {
          var qvImgs = (p.images && p.images.length ? p.images : (p.featured_image ? [p.featured_image] : []))
            .slice(0, 5).map(function (u) { return u.replace(/\.([^.]+)$/, '_600x600.$1'); });
          var img = qvImgs[0] || '';
          var price = (p.price / 100).toFixed(0);
          var comparePrice = p.compare_at_price ? (p.compare_at_price / 100).toFixed(0) : '';

          var sizesHtml = '';
          p.variants.forEach(function(v) {
            var label = v.title || v.option1 || '';
            sizesHtml += '<button class="su-qv__size' + (v.available ? '' : '" disabled') + '" data-variant-id="' + v.id + '">' + label + '</button>';
          });

          var priceHtml = comparePrice && comparePrice !== price
            ? '<span style="text-decoration:line-through;opacity:0.5;margin-right:8px;">' + comparePrice + ' AED</span>' + price + ' AED'
            : price + ' AED';

          bodyEl.innerHTML = '' +
            '<div class="su-qv__media">' +
              '<img class="su-qv__img" src="' + img + '" alt="' + (p.title || '') + '">' +
              (qvImgs.length > 1
                ? '<button type="button" class="su-qv__nav su-qv__nav--prev" aria-label="Previous">‹</button>' +
                  '<button type="button" class="su-qv__nav su-qv__nav--next" aria-label="Next">›</button>' +
                  '<span class="su-qv__dots">1/' + qvImgs.length + '</span>'
                : '') +
            '</div>' +
            '<div>' +
              '<h2 class="su-qv__title">' + p.title + '</h2>' +
              '<div class="su-qv__price">' + priceHtml + '</div>' +
              (sizesHtml ? '<div class="su-qv__sizes">' + sizesHtml + '</div>' : '') +
              '<button class="su-qv__atc" disabled>Select a size</button>' +
              '<a class="su-qv__link" href="/products/' + handle + '">View full details</a>' +
            '</div>';

          if (qvImgs.length > 1) {
            var qvIdx = 0;
            var imgEl = bodyEl.querySelector('.su-qv__img');
            var dotsEl = bodyEl.querySelector('.su-qv__dots');
            var qvShow = function (n) {
              qvIdx = (n + qvImgs.length) % qvImgs.length;
              imgEl.src = qvImgs[qvIdx];
              dotsEl.textContent = (qvIdx + 1) + '/' + qvImgs.length;
            };
            bodyEl.querySelector('.su-qv__nav--prev').addEventListener('click', function (e) { e.stopPropagation(); qvShow(qvIdx - 1); });
            bodyEl.querySelector('.su-qv__nav--next').addEventListener('click', function (e) { e.stopPropagation(); qvShow(qvIdx + 1); });
          }

          var selectedVariantId = null;
          var atcBtn = bodyEl.querySelector('.su-qv__atc');
          var sizeBtns = bodyEl.querySelectorAll('.su-qv__size');

          if (p.variants.length === 1 && p.variants[0].available) {
            selectedVariantId = p.variants[0].id;
            if (sizeBtns[0]) sizeBtns[0].classList.add('is-active');
            atcBtn.disabled = false;
            atcBtn.textContent = 'Add to cart';
          }

          sizeBtns.forEach(function(btn) {
            btn.addEventListener('click', function() {
              sizeBtns.forEach(function(b) { b.classList.remove('is-active'); });
              btn.classList.add('is-active');
              selectedVariantId = btn.getAttribute('data-variant-id');
              atcBtn.disabled = false;
              atcBtn.textContent = 'Add to cart';

              var variant = p.variants.find(function(v) { return String(v.id) === String(selectedVariantId); });
              if (variant && variant.featured_image) {
                bodyEl.querySelector('.su-qv__img').src = variant.featured_image.src.replace(/\.([^.]+)$/, '_600x600.$1');
              }
            });
          });

          atcBtn.addEventListener('click', function() {
            if (!selectedVariantId) return;
            atcBtn.disabled = true;
            atcBtn.textContent = 'Adding...';

            var qvSectionList = 'cart-notification-product,cart-notification-button,cart-drawer,cart-icon-bubble,cart-live-region-text';
            /* 8s AbortController timeout per CLAUDE.md rule #10 */
            var qvCtrl = new AbortController();
            var qvTimer = setTimeout(function () { qvCtrl.abort(); }, 8000);
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                items: [{ id: parseInt(selectedVariantId), quantity: 1 }],
                sections: qvSectionList
              }),
              signal: qvCtrl.signal
            })
            .then(function(r) { clearTimeout(qvTimer); return r.json(); })
            .then(function(resp) {
              atcBtn.textContent = 'Added!';
              setTimeout(function() {
                closeModal();
                function trigger(state) {
                  var notif = document.querySelector('cart-notification');
                  if (notif && typeof notif.renderContents === 'function' && state.sections) {
                    try { notif.renderContents(state); return; } catch (_) {}
                  }
                  var drawer = document.querySelector('cart-drawer');
                  if (drawer && typeof drawer.renderContents === 'function' && state.sections) {
                    try { drawer.renderContents(state); return; } catch (_) {}
                  }
                  if (drawer && typeof drawer.open === 'function') drawer.open();
                }
                if (resp.sections) { trigger(resp); return; }
                fetch('/cart.js?sections=' + qvSectionList)
                  .then(function(r){ return r.json(); })
                  .then(trigger);
              }, 400);
            })
            .catch(function() {
              atcBtn.textContent = 'Error — try again';
              atcBtn.disabled = false;
            });
          });
        })
        .catch(function() {
          bodyEl.innerHTML = '<div style="text-align:center;padding:40px;grid-column:1/-1"><p>Could not load product.</p></div>';
        });
    });
  })();

  /* ========== SU QUICK ADD (inline size picker) ========== */
  (function() {
    function setAddedState(addBtn) {
      addBtn.classList.add('is-added');
      var lbl = addBtn.querySelector('.su-card-action__label');
      var originalText = addBtn.getAttribute('data-original-label') || (lbl ? lbl.textContent : 'Add');
      if (!addBtn.getAttribute('data-original-label')) {
        addBtn.setAttribute('data-original-label', originalText);
      }
      if (lbl) lbl.textContent = 'Added ✓';
      setTimeout(function() {
        addBtn.classList.remove('is-added');
        if (lbl) lbl.textContent = addBtn.getAttribute('data-original-label');
      }, 2200);
    }

    /* Try cart-notification first (cart_type:notification), fall back to
       cart-drawer (cart_type:drawer). Each has its own sections + renderContents. */
    function showCartUpdate(parsedState) {
      /* 2026-09-11 audit B2-26: Dawn's renderContents left the custom drawer half
         drawn from a grid add (items missing, header pushed down). The drawer now
         owns its refresh; use it when present. */
      if (typeof window.suCartRefresh === 'function') {
        try { window.suCartRefresh(true); return true; } catch (_) {}
      }
      var notif = document.querySelector('cart-notification');
      if (notif && typeof notif.renderContents === 'function' && parsedState && parsedState.sections) {
        try { notif.renderContents(parsedState); return true; } catch (_) {}
      }
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function' && parsedState && parsedState.sections) {
        try { drawer.renderContents(parsedState); return true; } catch (_) {}
      }
      if (drawer && typeof drawer.open === 'function') { drawer.open(); return true; }
      return false;
    }

    function addVariant(variantId, addBtn, sizesEl) {
      /* Request whichever cart sections are needed depending on which cart UI
         is active. We request both notification + drawer sections; Shopify
         only returns the ones whose section files exist + are referenced. */
      var sectionList = 'cart-notification-product,cart-notification-button,cart-drawer,cart-icon-bubble,cart-live-region-text';
      var body = {
        items: [{ id: variantId, quantity: 1 }],
        sections: sectionList,
        sections_url: window.location.pathname
      };
      /* 8s AbortController timeout per CLAUDE.md rule #10 */
      var qaCtrl = new AbortController();
      var qaTimer = setTimeout(function () { qaCtrl.abort(); }, 8000);
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
        body: JSON.stringify(body),
        signal: qaCtrl.signal
      })
      .then(function(r) { clearTimeout(qaTimer); if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function(resp) {
        if (sizesEl) sizesEl.removeAttribute('data-open');
        setAddedState(addBtn);

        var parsedState = resp;
        if (!parsedState.sections) {
          /* Some single-item /cart/add.js responses omit sections —
             refetch /cart.js with the same section list. */
          return fetch('/cart.js?sections=' + sectionList)
            .then(function(r){ return r.json(); })
            .then(function(state) { setTimeout(function(){ showCartUpdate(state); }, 250); });
        }
        setTimeout(function(){ showCartUpdate(parsedState); }, 250);
        if (typeof window.suRefreshUpsell === 'function') {
          try { window.suRefreshUpsell(); } catch (_) {}
        }
      })
      .catch(function() {
        addBtn.classList.remove('is-loading');
        var lbl = addBtn.querySelector('.su-card-action__label');
        if (lbl) lbl.textContent = 'Try again';
      });
    }

    function renderSizes(sizesEl, product, addBtn) {
      var html = '<div class="su-card-sizes__label"><span>' + PICK_SIZE_LABEL + '</span><button type="button" class="su-card-sizes__close" aria-label="' + CLOSE_LABEL + '">×</button></div>';
      product.variants.forEach(function(v) {
        var label = v.title === 'Default Title' ? 'Add' : (v.option1 || v.title || '—');
        html += '<button type="button" class="su-card-size" data-variant-id="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' + label + '</button>';
      });
      sizesEl.innerHTML = html;
      sizesEl.setAttribute('data-open', '');

      sizesEl.querySelector('.su-card-sizes__close').addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        sizesEl.removeAttribute('data-open');
      });

      sizesEl.querySelectorAll('.su-card-size').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          if (btn.disabled) return;
          sizesEl.querySelectorAll('.su-card-size').forEach(function(b){ b.disabled = true; });
          btn.classList.add('is-loading');
          addVariant(parseInt(btn.getAttribute('data-variant-id'), 10), addBtn, sizesEl);
        });
      });
    }

    document.addEventListener('click', function(e) {
      var addBtn = e.target.closest('.su-quick-add-trigger');
      if (!addBtn) return;
      e.preventDefault();
      e.stopPropagation();

      var handle = addBtn.getAttribute('data-product-handle');
      if (!handle) return;

      // Find or create the inline sizes container scoped to this card
      var card = addBtn.closest('[data-su-card], .su-card-wrap, .su-product-card');
      var sizesEl = card ? card.querySelector('[data-su-sizes]') : null;
      if (!sizesEl && card) {
        sizesEl = document.createElement('div');
        sizesEl.className = 'su-card-sizes';
        sizesEl.setAttribute('data-su-sizes', '');
        var actions = card.querySelector('.su-card-actions');
        if (actions && actions.parentNode) actions.parentNode.insertBefore(sizesEl, actions.nextSibling);
      }

      addBtn.classList.add('is-loading');

      fetch('/products/' + handle + '.js')
        .then(function(r) { return r.json(); })
        .then(function(product) {
          addBtn.classList.remove('is-loading');
          var available = product.variants.filter(function(v){ return v.available; });
          if (available.length === 0) return; // sold out — do nothing
          if (available.length === 1 && product.variants.length === 1) {
            // single variant total → straight add
            return addVariant(available[0].id, addBtn, null);
          }
          if (!sizesEl) {
            // no container available; fall back to opening quick view
            addBtn.classList.remove('is-loading');
            var fakeQv = document.createElement('button');
            fakeQv.className = 'su-quick-view-trigger';
            fakeQv.setAttribute('data-product-handle', handle);
            fakeQv.style.display = 'none';
            document.body.appendChild(fakeQv);
            fakeQv.click();
            fakeQv.remove();
            return;
          }
          renderSizes(sizesEl, product, addBtn);
        })
        .catch(function() {
          addBtn.classList.remove('is-loading');
        });
    });
  })();

  /* ========== SU WISHLIST ========== */
  document.addEventListener('DOMContentLoaded', function() {
    var STORAGE_KEY = 'su-wishlist';

    function getWishlist() {
      try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
      catch(e) { return []; }
    }

    function saveWishlist(list) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    }

    function syncWishlistUI() {
      var list = getWishlist();
      document.querySelectorAll('[data-su-wishlist]').forEach(function(btn) {
        var id = btn.getAttribute('data-su-wishlist');
        btn.classList.toggle('is-wishlisted', list.includes(id));
      });
    }

    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-su-wishlist]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();

      var id = btn.getAttribute('data-su-wishlist');
      var list = getWishlist();

      if (list.includes(id)) {
        list = list.filter(function(x) { return x !== id; });
        btn.classList.remove('is-wishlisted');
      } else {
        list.push(id);
        btn.classList.add('is-wishlisted');
      }

      saveWishlist(list);
      btn.style.transform = 'scale(1.3)';
      setTimeout(function() { btn.style.transform = ''; }, 200);
    });

    syncWishlistUI();
  });
}